module.exports = __webpack_public_path__ + "static/media/exploretech_la_2022_Liability_Waiver.d6809e1c.pdf";